/**
 * @generated SignedSource<<0f3a3a9e1e7b3154f7a55bb74bf53f86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ViewerDismissedElementInput = {
  clientMutationId?: string | null;
  key: string;
};
export type DismissibleElementsMutation$variables = {
  input: ViewerDismissedElementInput;
};
export type DismissibleElementsMutation$data = {
  readonly viewerDismissedElement: {
    readonly viewer: {
      readonly dismissedElements: ReadonlyArray<{
        readonly dismissedCount: number;
        readonly firstDismissedAt: string | null;
        readonly id: string;
        readonly key: string;
        readonly lastDismissedAt: string | null;
      }>;
      readonly id: string;
    } | null;
  } | null;
};
export type DismissibleElementsMutation$rawResponse = {
  readonly viewerDismissedElement: {
    readonly viewer: {
      readonly dismissedElements: ReadonlyArray<{
        readonly dismissedCount: number;
        readonly firstDismissedAt: string | null;
        readonly id: string;
        readonly key: string;
        readonly lastDismissedAt: string | null;
      }>;
      readonly id: string;
    } | null;
  } | null;
};
export type DismissibleElementsMutation = {
  rawResponse: DismissibleElementsMutation$rawResponse;
  response: DismissibleElementsMutation$data;
  variables: DismissibleElementsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ViewerDismissedElementPayload",
    "kind": "LinkedField",
    "name": "viewerDismissedElement",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DismissedElement",
            "kind": "LinkedField",
            "name": "dismissedElements",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstDismissedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastDismissedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dismissedCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DismissibleElementsMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DismissibleElementsMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "5afdd5c5ccf42ff46c85ac671748394e",
    "id": null,
    "metadata": {},
    "name": "DismissibleElementsMutation",
    "operationKind": "mutation",
    "text": "mutation DismissibleElementsMutation(\n  $input: ViewerDismissedElementInput!\n) {\n  viewerDismissedElement(input: $input) {\n    viewer {\n      id\n      dismissedElements {\n        id\n        key\n        firstDismissedAt\n        lastDismissedAt\n        dismissedCount\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5396ad8caec37ff0135605838249ca50";

export default node;
